class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
      window.location.reload()
    }, 500);

    // const facetForm = this.querySelector('form');
    const facetFormBtn = document.querySelector('form .facets__form-button');
    if (facetFormBtn) {
      facetFormBtn.addEventListener('click', this.debouncedOnSubmit.bind(this));
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    $('.filter__custom-dropdown__filter-input').on('click', function () {
      const $group = $(this).closest('.filter__custom-dropdown__filter-group')
      const totalActiveCount = $group.find('.filter__custom-dropdown__filter-input:checked').length;
      if (totalActiveCount == 0) {
        $group.siblings('.filter__custom-dropdown__summary-label').children('span').addClass('hidden');
      }
      else {
        $group.siblings('.filter__custom-dropdown__summary-label').children('span').removeClass('hidden').html(totalActiveCount);
      }
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    if (document.getElementById('prod-count')) {
      document.getElementById('prod-count').innerHTML = count;
      $('.current__productCount').text($('.current__products').text());
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }

    // close custom dropdown after applying filters
    const filterDropdown = document.querySelector('.filter__custom-dropdown-wrapper');
    if (filterDropdown && filterDropdown.classList.contains('active')) {
      // filterDropdown.classList.remove('active');
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);


class FacetFiltersDropdown extends HTMLElement {
  constructor() {
    super();
    // dropdown toggle
    $('.title', $(this)).on('click', function () {
      if (!$(this).hasClass('active')) {
        $('facet-filters-dropdown .title').removeClass('active');
        $('facet-filters-dropdown .dropdown-container').removeClass('active');
      }
      $(this).toggleClass('active');
      $(this).siblings('.dropdown-container').toggleClass('active');
    });
  }

  static setListeners() {
    // close dropdown when clicked outside
    window.addEventListener('click', (e) => {
      let close = true;

      document.querySelectorAll('facet-filters-dropdown').forEach((customOption) => {
        if (e.target == customOption) {
          close = false;
        };
      });

      document.querySelectorAll('facet-filters-dropdown .title').forEach((customOption) => {
        if (e.target == customOption) {
          close = false;
        };
      });

      document.querySelectorAll('facet-filters-dropdown .title span').forEach((customOption) => {
        if (e.target == customOption) {
          close = false;
        };
      });

      document.querySelectorAll('facet-filters-dropdown ul').forEach((customOption) => {
        if (e.target == customOption) {
          close = false;
        };
      });

      document.querySelectorAll('facet-filters-dropdown ul li').forEach((customOption) => {
        if (e.target == customOption) {
          close = false;
        };
      });
      document.querySelectorAll('facet-filters-dropdown ul li span').forEach((customOption) => {
        if (e.target == customOption) {
          close = false;
        };
      });
      document.querySelectorAll('facet-filters-dropdown button').forEach((customOption) => {
        if (e.target == customOption) {
          close = false;
        };
      });
      if ($('facet-filters-dropdown .title.active').length > 0 &&
        $('facet-filters-dropdown .dropdown-container.active').length > 0 &&
        close
      ) {
        $('facet-filters-dropdown .title.active').removeClass('active');
        $('facet-filters-dropdown .dropdown-container.active').removeClass('active');
      };
    });

    // dropdown items
    $('facet-filters-dropdown li').on('click', function(){
      $(this).toggleClass('active');
      const $group = $(this).closest('.dropdown-container');
      const totalActiveCount = $group.find('li.active').length;
      $group.siblings('.title').find('span').remove();
      $group.find('.facet-apply-button').removeClass('disabled');
      if (totalActiveCount > 0) {
        $group.siblings('.title').append(`<span>${totalActiveCount}</span>`);
      }
    });

    $('.facet-apply-button').on('click', function(){
      if(!$(this).hasClass('disabled')) {
        $('#FacetFiltersForm .filter__custom-dropdown__filter-group input').removeAttr('checked');
        $('.filter-filters-group facet-filters-dropdown li.active').each(function() {
          let selection = $(this).find('span').attr('name');
          $(`#FacetFiltersForm .filter__custom-dropdown__filter-group input[id="${selection}"]`).prop('checked', true);
        })
        $('#FacetFiltersForm').submit();
      }
    });

    $('[data-clear-all]').on('click', function(e){
      e.preventDefault();
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const newUrlParams = new URLSearchParams();
      urlParams.forEach((value, key) => {
        if(key.indexOf('filter') == -1 || key == 'filter.p.product_type'){
          newUrlParams.append(key, value);
        }
      })
      
      window.location.href = `${window.location.pathname}?${newUrlParams.toString()}`;      
    })
  }
}

customElements.define('facet-filters-dropdown', FacetFiltersDropdown);
FacetFiltersDropdown.setListeners();